export const QUERY_KEY = {
	GET_SEARCH: 'GET_SEARCH',
	GET_CATEGORY: 'GET_CATEGORY',
	GET_CATEGORY_INFINITE: 'GET_CATEGORY_INFINITE',
	GET_DETAIL: 'GET_DETAIL',
	GET_TRAILER: 'GET_TRAILER',
}
